import React from "react";
import PropTypes from "prop-types";
import Card from "components/Card";
import { Col } from "components/Containers";
import { Spinner } from "components/Loader";
import {
  RoleCodeChallenges,
  RoleRequirements,
  RoleQuestionnaire,
  RoleInterviewQuestions,
} from "components/Missions/Roles";

/**
 * BlueprintVetting
 *
 * The vetting modules a customer adjusts after picking a blueprint, each saving through
 * its own mutation rather than the builder's form.
 *
 * @param {Object}    role     The draft being built
 * @param {Boolean}   loading  The draft is still being read back
 * @param {Function}  refetch  Re-reads the draft after a module saves
 * @param {Boolean}   canEdit  Whether the modules may be changed; false renders them for review
 * @param {Array}     refetchQueries  Queries to re-read after the requirements or code challenges change
 * @param {Boolean}   canRemoveRequirements  Whether requirements may be deleted outright, as an admin does on a blueprint
 */
const BlueprintVetting = ({
  role,
  loading,
  refetch,
  canEdit = true,
  refetchQueries,
  canRemoveRequirements,
  ...props
}) => {
  if (loading || !role?.id) return <Spinner />;

  return (
    <div onSubmit={(event) => event.stopPropagation()}>
      <Col gap="2rem">
        <Card>
          <RoleRequirements
            missionRole={role}
            refetch={refetch}
            refetchQueries={refetchQueries}
            canEdit={canEdit}
            canRemove={canRemoveRequirements}
          />
        </Card>
        <Card>
          <RoleQuestionnaire missionRole={role} refetch={refetch} canEdit={canEdit} />
        </Card>
        <Card>
          <RoleInterviewQuestions missionRole={role} canEdit={canEdit} {...props} />
        </Card>
        <Card>
          <RoleCodeChallenges data={role} refetchQueries={refetchQueries} canEdit={canEdit} />
        </Card>
      </Col>
    </div>
  );
};

BlueprintVetting.propTypes = {
  role: PropTypes.object,
  loading: PropTypes.bool,
  refetch: PropTypes.func,
  canEdit: PropTypes.bool,
  refetchQueries: PropTypes.array,
  canRemoveRequirements: PropTypes.bool,
};

export default BlueprintVetting;
